import { createApp, h } from 'vue'
import { createInertiaApp, usePage } from '@inertiajs/inertia-vue3'
import { InertiaProgress } from '@inertiajs/progress'
import Layout from "./Shared/Layouts/Layout";
import Emitter from 'tiny-emitter';
import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css'

const emitter = new Emitter();
InertiaProgress.init({color: '#ee8225'})

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

createInertiaApp({
    title: title => `${title}${usePage().props.value.organisation_name ? ' - '+usePage().props.value.organisation_name : ''}`,
    resolve: name => {
        const page = require(`./Pages/${name}`).default
        if (page.layout === undefined) {
          page.layout = Layout
        }
      return page
    },
    setup({ el, App, props, plugin }) {
      createApp({ render: () => h(App, props) })
          .use(plugin)
          .use(FloatingVue, {
            themes: {
              'info': {
                $extend: 'tooltip'
              },
            },
          })
          .mixin({ methods: { route } })
          .mixin(require('./Mixins/Translations'))
          .mixin(require('./Mixins/Authorization'))
          .mount(el)
    },
})
